"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledH80 = exports.StyledH60 = exports.StyledH40 = exports.StyledH20 = exports.StyledH140 = exports.StyledH120 = exports.StyledH100 = exports.StyledH10 = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _theme = _interopRequireDefault(require("../../theme"));
var _typographyHelper = require("../../utils/typographyHelper");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var BaseHeading = (0, _styledComponents.css)(["margin:0;padding:0;font-family:", ";font-size:", ";font-weight:600;font-style:normal;font-stretch:normal;text-align:", ";line-height:", ";letter-spacing:normal;color:", ";", " ", ""], _theme["default"].buenosAires, (0, _typographyHelper.pxToRem)(32), function (props) {
  return props.textAlign;
}, (0, _typographyHelper.getLineHeight)({
  fontSize: 32,
  expectedLineHeight: 40
}), _theme["default"].textColor, function (props) {
  return props.color === 'light' && (0, _styledComponents.css)(["color:", ";"], _theme["default"].textColorLight);
}, function (props) {
  return props.color === 'white' && (0, _styledComponents.css)(["color:white;"]);
});
var StyledH140 = exports.StyledH140 = _styledComponents["default"].h1.withConfig({
  displayName: "styled-components__StyledH140",
  componentId: "sc-1sz9c1e-0"
})(["", ";font-size:", ";line-height:", ";", " ", ""], BaseHeading, (0, _typographyHelper.pxToRem)(32), (0, _typographyHelper.getLineHeight)({
  fontSize: 32,
  expectedLineHeight: 40
}), _theme["default"].mediaMediumPlus(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), (0, _typographyHelper.pxToRem)(40), (0, _typographyHelper.getLineHeight)({
  fontSize: 40,
  expectedLineHeight: 50
})), _theme["default"].mediaLargePlus(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), (0, _typographyHelper.pxToRem)(48), (0, _typographyHelper.getLineHeight)({
  fontSize: 48,
  expectedLineHeight: 60
})));
var StyledH120 = exports.StyledH120 = _styledComponents["default"].h1.withConfig({
  displayName: "styled-components__StyledH120",
  componentId: "sc-1sz9c1e-1"
})(["", ";font-size:", ";line-height:", ";", " ", ""], BaseHeading, (0, _typographyHelper.pxToRem)(26), (0, _typographyHelper.getLineHeight)({
  fontSize: 26,
  expectedLineHeight: 32
}), _theme["default"].mediaMediumPlus(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), (0, _typographyHelper.pxToRem)(36), (0, _typographyHelper.getLineHeight)({
  fontSize: 36,
  expectedLineHeight: 44
})), _theme["default"].mediaLargePlus(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), (0, _typographyHelper.pxToRem)(40), (0, _typographyHelper.getLineHeight)({
  fontSize: 40,
  expectedLineHeight: 48
})));
var StyledH100 = exports.StyledH100 = _styledComponents["default"].h2.withConfig({
  displayName: "styled-components__StyledH100",
  componentId: "sc-1sz9c1e-2"
})(["", ";font-size:", ";line-height:", ";", " ", ""], BaseHeading, (0, _typographyHelper.pxToRem)(24), (0, _typographyHelper.getLineHeight)({
  fontSize: 24,
  expectedLineHeight: 30
}), _theme["default"].mediaMediumPlus(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), (0, _typographyHelper.pxToRem)(32), (0, _typographyHelper.getLineHeight)({
  fontSize: 32,
  expectedLineHeight: 42
})), _theme["default"].mediaLargePlus(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), (0, _typographyHelper.pxToRem)(36), (0, _typographyHelper.getLineHeight)({
  fontSize: 36,
  expectedLineHeight: 47
})));
var StyledH80 = exports.StyledH80 = _styledComponents["default"].h3.withConfig({
  displayName: "styled-components__StyledH80",
  componentId: "sc-1sz9c1e-3"
})(["", ";font-size:", ";line-height:", ";", " ", ""], BaseHeading, (0, _typographyHelper.pxToRem)(22), (0, _typographyHelper.getLineHeight)({
  fontSize: 22,
  expectedLineHeight: 28
}), _theme["default"].mediaMediumPlus(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), (0, _typographyHelper.pxToRem)(24), (0, _typographyHelper.getLineHeight)({
  fontSize: 24,
  expectedLineHeight: 32
})), _theme["default"].mediaLargePlus(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), (0, _typographyHelper.pxToRem)(28), (0, _typographyHelper.getLineHeight)({
  fontSize: 28,
  expectedLineHeight: 36
})));
var StyledH60 = exports.StyledH60 = _styledComponents["default"].h4.withConfig({
  displayName: "styled-components__StyledH60",
  componentId: "sc-1sz9c1e-4"
})(["", ";font-size:", ";line-height:", ";", ""], BaseHeading, (0, _typographyHelper.pxToRem)(20), (0, _typographyHelper.getLineHeight)({
  fontSize: 20,
  expectedLineHeight: 26
}), _theme["default"].mediaLargePlus(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), (0, _typographyHelper.pxToRem)(22), (0, _typographyHelper.getLineHeight)({
  fontSize: 22,
  expectedLineHeight: 29
})));
var StyledH40 = exports.StyledH40 = _styledComponents["default"].h5.withConfig({
  displayName: "styled-components__StyledH40",
  componentId: "sc-1sz9c1e-5"
})(["", ";font-size:", ";line-height:", ";"], BaseHeading, (0, _typographyHelper.pxToRem)(18), (0, _typographyHelper.getLineHeight)({
  fontSize: 18,
  expectedLineHeight: 24
}));
var StyledH20 = exports.StyledH20 = _styledComponents["default"].h6.withConfig({
  displayName: "styled-components__StyledH20",
  componentId: "sc-1sz9c1e-6"
})(["", ";font-size:", ";line-height:", ";"], BaseHeading, (0, _typographyHelper.pxToRem)(16), (0, _typographyHelper.getLineHeight)({
  fontSize: 16,
  expectedLineHeight: 20
}));
var StyledH10 = exports.StyledH10 = _styledComponents["default"].h6.withConfig({
  displayName: "styled-components__StyledH10",
  componentId: "sc-1sz9c1e-7"
})(["", ";font-size:", ";line-height:", ";"], BaseHeading, (0, _typographyHelper.pxToRem)(12), (0, _typographyHelper.getLineHeight)({
  fontSize: 12,
  expectedLineHeight: 16
}));